<template>
    <div class="article-previews">
        <ArticleGridItem
            v-for="(article, key) in data.articles"
            :key="key"
            :data="article"
            :has-eager-image="hasEagerImage && key < 3"
        />
    </div>
</template>

<script setup lang="ts">
import type { ComponentArticleGridFragment } from '@/graphql/api'

import ArticleGridItem from '@/components/cms/component/article-grid/ArticleGridItem.vue'

defineProps<{
    data: ComponentArticleGridFragment
    hasEagerImage?: boolean
}>()
</script>

<style lang="scss" scoped>
.article-previews {
    width: 1140px;
    max-width: 100%;
    margin: 0 auto 60px;
    padding: 0 0 20px;

    @include min-width(640) {
        padding: 0 20px 20px;
    }

    @include min-width(1024) {
        display: grid;
        grid-template-columns: 1fr 1fr 1fr;
        column-gap: 30px;
    }

    @include min-width(1140) {
        padding: 0 0 20px;
    }
}
</style>
